export default __webpack_public_path__ + "static/SignageLight-dc3875ddfc13b014fec8c2d4c7b3a38b.png";